// extracted by mini-css-extract-plugin
export var checkbox = "_9j-0";
export var circle = "_9j-3";
export var horizontalContainer = "_9j-7";
export var sm = "_9j-5";
export var switch0 = "_9j-2";
export var switchDisabled = "_9j-8";
export var switchEnabled = "_9j-1";
export var textSwitchContainer = "_9j-9";
export var textSwitchOption = "_9j-a";
export var textSwitchOptionSelected = "_9j-b";
export var verticalContainer = "_9j-6";
export var xs = "_9j-4";